import ListContainer from '../../../../components/shared/ListContainer';
import ListItem from '../../../../components/shared/ListItem';
import {IResource} from '../../../../models/resource';
import {useState} from 'react';
import ResourceModal from '../../../../components/shared/ResourceModal';
import {useAppDispatch} from '../../../../store/app-hooks';
import {clearError, deleteResource} from '../../../../store/resource/resource';
import useConfirm from '../../../../hooks/useConfirm';
import {useNotification} from '../../../../store/notification/NotificationContext';
import {FIELD_LABELS} from '../../../../constants';

type GeneralResourcesConfigProps = {
    generalResources: IResource[];
};

export const GeneralResourcesConfig = ({generalResources}: GeneralResourcesConfigProps) => {
    const dispatch = useAppDispatch();
    const {confirm} = useConfirm();
    const {addNotification} = useNotification();

    const [openNewModal, setOpenNewModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);

    const [selectedResource, setSelectedResource] = useState<IResource>();

    const {SUCCESSFUL_DELETION, FAIL_DELETION, DELETE_OBJECT, MODAL_CONFIRMATION} = FIELD_LABELS;

    // const handleViewArchivedClick = () => {};

    const onCloseNewModal = () => {
        dispatch(clearError());
        setOpenNewModal(false);
    };

    const handleEditModal = (currResource: IResource) => {
        setOpenEditModal(true);
        setSelectedResource(currResource);
    };

    const onCloseEditModal = () => {
        dispatch(clearError());
        setOpenEditModal(false);
    };

    const onDeleteResource = async (resourceId: string) => {
        const result = await confirm(MODAL_CONFIRMATION, DELETE_OBJECT);

        if (result) {
            dispatch(deleteResource(resourceId))
                .unwrap()
                .then(() => addNotification(SUCCESSFUL_DELETION, 'success'))
                .catch(() => addNotification(FAIL_DELETION, 'error'));
        }
    };

    return (
        <>
            <ListContainer
                onAddClick={() => setOpenNewModal(true)}
                // onViewArchivedClick={handleViewArchivedClick}
                title="General Resources"
            >
                {generalResources.map((resource) => (
                    <ListItem
                        key={resource.id}
                        title={resource.title}
                        onDeleteClick={() => onDeleteResource(resource.id)}
                        onEditClick={() => handleEditModal(resource)}
                    />
                ))}
            </ListContainer>
            {openNewModal && <ResourceModal closeModal={onCloseNewModal} isLitterBag={false} />}
            {openEditModal && (
                <ResourceModal
                    resource={selectedResource}
                    closeModal={onCloseEditModal}
                    isLitterBag={false}
                />
            )}
        </>
    );
};
